import React from 'react';
import {Edit} from 'react-admin';
import {SystemForm} from 'ReactAdminPages/Systems/SystemForm';

export const SystemEdit = (props: unknown): React.ReactElement => <Edit {...props}>
    <SystemForm {...props}/>
</Edit>;

